export const linksDocente = [
  {
    name: 'Dashboard',
    icon: 'home',
    path: '/docente/dashboard'
  },
  {
    name: 'Relatórios',
    icon: 'paper',
    path: '/docente/relatorios'
  },
  {
    name: 'Bolsistas',
    icon: 'list',
    path: '/docente/lista'
  },
  {
    name: 'Bolsas Expiradas',
    icon: 'cancel',
    path: '/docente/bolsas/expiradas'
  },
  {
    name: 'Perfil',
    icon: 'profile',
    path: '/docente/perfil'
  }
]
